import { TaskTemplateStep } from "Models/Tasks/TaskTemplateStep";

export class ChecklistItemTemplate {
    public id?: number;
    public name: string;
    public pictureUrl?: string;
    public descriptionFileUrl?: string;
    public description: string;
    public type: string = "checklist";
    public positionIndex: number;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public videoUrl?: string;
    public videoThumbnailUrl?: string;
    public steps: TaskTemplateStep[] = [];
    
    public pictureFile?: File;
    public videoFile?: File;
    public videoThumbnailFile?: File;
    public descriptionFile?: File;
}


// WEBPACK FOOTER //
// ./src/Models/Checklists/ChecklistItemTemplate.ts